require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-glennsl-rebase.json") })
        }
      }, "path---package-glennsl-rebase");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-glennsl-rebase!./.cache/json/package-glennsl-rebase.json
// module id = 866
// module chunks = 231608221292675